import Divider from '@UI/divider/Divider';
import GoalLink from '@UI/goalLink/GoalLink';
import NonderivedMenuOptions from '@UI/nonderivedMenuOptions/NonderivedMenuOptions';
import ReadOrderViz from '@UI/readOrderViz/ReadOrderViz';
import GoalExtraIcon from '@assets/img/icon_extra_white.svg?react';
import ConcretizationIcon from '@assets/img/icon_eye.svg?react';
import GoalExplanationIcon from '@assets/img/icon_goal_explanation.svg?react';
import InitialSituationIcon from '@assets/img/icon_initial_situation.svg?react';
import TipIcon from '@assets/img/icon_pedagogical_tip.svg?react';
import { getCompilerOptions } from '@utils/compilerOptionsHelper';
import { Compiler } from '@kathondvla/react-shared-components/src/components';
import { includeItem } from '@store/llinkidApis/llinkidApiState';
import { CONTENTTYPES } from '@utils/curriculumHelper';
import { useDispatch } from 'react-redux';

import './goalSubItem.scss';
import { trackIncludeSubItem } from '@store/tracking/trackingSagas';

const ICON = {
  [CONTENTTYPES.tip]: {
    title: 'Wenk',
    eventTitle: 'tip',
    component: <TipIcon />,
  },
  [CONTENTTYPES.goalExplanation]: {
    title: 'Duiding',
    eventTitle: 'goal_explanation',
    component: <GoalExplanationIcon />,
  },
  [CONTENTTYPES.goalExtra]: {
    title: 'Extra',
    eventTitle: 'goal_extra',
    component: <GoalExtraIcon style={{ transform: 'scale(1)' }} />,
  },
  [CONTENTTYPES.initialSituation]: {
    title: 'Beginsituatie',
    eventTitle: 'initial_situation',
    component: <InitialSituationIcon style={{ transform: 'scale(1)' }} />,
  },
  [CONTENTTYPES.concretization]: {
    title: 'Concretisering',
    eventTitle: 'concretization',
    component: <ConcretizationIcon style={{ transform: 'scale(1)' }} />,
  },
};

const GoalSubItem = ({ item, onShowEditGoalModal, onShowNonderivedModal, termModalRef }) => {
  const dispatch = useDispatch();
  const includeGoalSubItem = (goal) => {
    dispatch(trackIncludeSubItem({ type: ICON[item.type].eventTitle, include: item.excluded }));
    dispatch(includeItem({ item: goal }));
  };
  const compilerOptions = getCompilerOptions({
    terms: item.terms,
    markExplanations: item.markExplanations,
    termModalRef,
  });

  if (item.hidden) return null;

  if (
    item.type === CONTENTTYPES.goalExplanation ||
    item.type === CONTENTTYPES.tip ||
    item.type === CONTENTTYPES.goalExtra ||
    item.type === CONTENTTYPES.initialSituation ||
    item.type === CONTENTTYPES.concretization
  ) {
    return (
      <>
        <div
          className={`goal-sub-item ${item.excluded ? 'excluded' : ''} ${
            item.partialInclusion ? 'partial' : ''
          }`}
        >
          <div className="left-section">
            <div className="item-icon">{ICON[item.type].component}</div>
            <Divider mandatory={item.mandatory} />
          </div>
          <NonderivedMenuOptions
            goal={item}
            onShowEditGoalModal={onShowEditGoalModal}
            onShowNonderivedModal={onShowNonderivedModal}
            onExclude={includeGoalSubItem}
          >
            <div className="content">
              <span className="title">{ICON[item.type].title}</span>
              {item.type === CONTENTTYPES.concretization && item.isNew && (
                <span className="concretization-label">NIEUW</span>
              )}
              <div className="description">
                <Compiler text={item.description} options={compilerOptions} />
              </div>
              {item.type !== CONTENTTYPES.initialSituation && <ReadOrderViz item={item} />}
            </div>
            {item.type === CONTENTTYPES.initialSituation && (
              <div className="right-section">
                <GoalLink links={item.relatedGoals} />
                <ReadOrderViz item={item} />
              </div>
            )}
          </NonderivedMenuOptions>
        </div>
        <div className="sub-items">
          {item.subItems?.map((subItem) => (
            <GoalSubItem
              key={subItem.key}
              item={subItem}
              onShowEditGoalModal={onShowEditGoalModal}
              onShowNonderivedModal={onShowNonderivedModal}
              termModalRef={termModalRef}
            />
          ))}
        </div>
      </>
    );
  }

  console.warn('item of unknown item.type', item);
  return null;
};

export default GoalSubItem;
